import React, { useMemo, useState } from 'react'
import '../../components/kyc/kycStyle.css'
import './DeedsQuery.css'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import { API_ERROR_MESSAGE, PRICELIST } from '../../utils/Constants'
import { RESTRICTED_REPORT } from '../../utils/Constants'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import { useMutation } from 'react-query'
import { requestDeedsQuery } from '../../api/deedsQuery'
import { Spinner } from 'react-bootstrap'
type DeedsQueryProps = {
  setShow: (value: boolean) => void
  setIsError: (arg0: boolean) => void
  setErrorMessage: (value: string) => void
  KYCAccess: boolean
}

const DeedsQuery: React.FC<DeedsQueryProps> = ({
  setShow,
  setIsError,
  setErrorMessage,
  KYCAccess,
}) => {
  const [hfAllotment] = useState(
    (document.getElementById('hfAllotment') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? 'Allotment' : ''),
  )
  const [hfAddress] = useState(
    (document.getElementById('hfAddress') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? '15 suikerbossie street' : ''),
  )
  const [hfSalePrice] = useState(
    (document.getElementById('hfReportedSalePrice') as HTMLInputElement)
      ?.value || (process.env.REACT_APP_ENV === 'DEV' ? '15' : ''),
  )
  const [hfSaleDate] = useState(
    (document.getElementById('hfReportedSaleDate') as HTMLInputElement)
      ?.value || (process.env.REACT_APP_ENV === 'DEV' ? '22 January 2020' : ''),
  )
  const [hfRegisteredDate] = useState(
    (document.getElementById('hfRegisteredDate') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? '23 January 2020' : ''),
  )
  const [hfBondAmount] = useState(
    (document.getElementById('hfBondAmount') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? 'R1500' : ''),
  )
  const [hfOwner] = useState(
    (document.getElementById('hfOwner') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? 'Vincent Van Wyk' : ''),
  )
  const [hfErfNo] = useState(
    (document.getElementById('hfErfNo') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? '1234' : ''),
  )
  const [hfTitleDeed] = useState(
    (document.getElementById('hfTitleDeed') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? 'The Title Deed' : ''),
  )
  const [hfCMAID] = useState(
    (document.getElementById('hfCMAID') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? '3035217' : ''),
  )
  const [hfSchemeNo] = useState(
    (document.getElementById('hfSchemeNo') as HTMLInputElement)?.value,
  )
  const [hfSectionNo] = useState(
    (document.getElementById('hfSectionNo') as HTMLInputElement)?.value,
  )

  const legalDescription = useMemo(() => {
    return `Erf ${hfErfNo}, ${hfAllotment}`
  }, [hfErfNo, hfAllotment])

  //useMutation call for proceed event here
  const { mutate: proceed, isLoading: isLoadingProceed } = useMutation(
    'deeds-query-proceed',
    requestDeedsQuery,
    {
      onSuccess: () => {
        alert('An email with your report will be sent to you shortly')
      },
      onError: () => {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      },
    },
  )

  const handleSearch = async () => {
    await proceed({
      cmaid: hfCMAID,
      schemeNo: hfSchemeNo,
      sectionNo: hfSectionNo,
    })
  }

  const subHeader = (
    <span>
      A Deeds Office enquiry provides information of the current and historical{' '}
      <br />
      ownership of the property
    </span>
  )

  return (
    <ScreenLayout
      headerText="Deeds Query"
      subHeaderText={subHeader}
      price={PRICELIST.DEEDS_QUERY}
    >
      {isLoadingProceed && (
        <>
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        </>
      )}
      {KYCAccess !== true && <p className="lbl-red">{RESTRICTED_REPORT}</p>}

      <table style={{ width: '565px', marginTop: '20px' }}>
        <tr className="rowBorder">
          <td
            className="labelMargin colBorderSpliter"
            style={{ width: '150px' }}
          >
            <span className="detailLabel">Legal Description:</span>
          </td>
          <td className="labelMargin">
            <span className="">{legalDescription}</span>
          </td>
        </tr>

        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Adrress:</span>
          </td>
          <td className="labelMargin">
            <span className="">{hfAddress}</span>
          </td>
        </tr>

        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Owner(s):</span>
          </td>
          <td className="labelMargin">
            <span className="">
              {hfOwner.split(';').map((owner, index) => (
                <div key={index}>
                  <span>{owner.trim()}</span>
                  {index < hfOwner.length - 1 && <br />}
                </div>
              ))}
            </span>
          </td>
        </tr>

        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Sale Price:</span>
          </td>
          <td className="labelMargin">
            <span className="">
              {' '}
              R {hfSalePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
            </span>
          </td>
        </tr>

        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Sale Date:</span>
          </td>
          <td className="labelMargin">
            <span className="">{hfSaleDate}</span>
          </td>
        </tr>

        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Registered Dates:</span>
          </td>
          <td className="labelMargin">
            <span className="">{hfRegisteredDate}</span>
          </td>
        </tr>

        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Bond Amount:</span>
          </td>
          <td className="labelMargin">
            <span className="">
              R {hfBondAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
            </span>
          </td>
        </tr>

        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Title Deed:</span>
          </td>
          <td className="labelMargin">
            <span className="">{hfTitleDeed}</span>
          </td>
        </tr>
      </table>

      <div className="spacer" />
      <FooterButtons
        handleSearch={handleSearch}
        searchChildren="Proceed"
        setShow={setShow}
      />
      <div className="spacer" />
    </ScreenLayout>
  )
}
export default DeedsQuery
